//Checa se todos os checkboxes estão selecionados
function testAllCheckboxSelect(listaCheckboxTabela){
    var r = true;
    listaCheckboxTabela.each(function(){
        if(!$(this).find('input')[0].checked){
            return r = false;
        }
    });
    return r;
}

function init(listaCheckBox, checkBoxController){
    
    //Identificador da lista que vai conter todos os checkbox
    var listaCheckboxTabela = $(listaCheckBox).find(".icheckbox_square-custom");
    
    // Identificador do checkbox que vai acionar as ações em todos os checkbox
    var checkControleTabela = $(checkBoxController);
    
    // Se o checkbox "todos"for clicado.
    checkControleTabela.on('ifClicked',function(){
        if($(this)[0].checked){
            listaCheckboxTabela.each(function(){
                $(this).iCheck('uncheck');
            });
        }else{
            listaCheckboxTabela.each(function(){
                $(this).iCheck('check');
            });
        }
    });


    listaCheckboxTabela.each(function(){
        $(this).on('ifClicked',function(){
            if($(this).find('input')[0].checked){
                checkControleTabela.iCheck('uncheck');
            }else{
                $(this).iCheck('check');
                var checado = testAllCheckboxSelect(listaCheckboxTabela);
                if(checado){
                    checkControleTabela.iCheck('check');
                }
            }
        });
    });
}

module.exports = {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/selecionar-todos-checkbox.js